import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/published.png'


import { onMounted } from "vue";
import MainHeader from "@/components/main-header.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticlePublished',
  setup(__props) {

onMounted(async () => {
  console.log("coming in");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MainHeader),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"timeline-container\" data-v-4aa9b3e6><div class=\"entry-list\" data-v-4aa9b3e6><div class=\"infor-list\" data-v-4aa9b3e6><div class=\"content-flag\" data-v-4aa9b3e6><div class=\"common-empty\" data-v-4aa9b3e6><img src=\"" + _imports_0 + "\" data-v-4aa9b3e6></div><div class=\"published-ok\" data-v-4aa9b3e6>发布成功！等待管理员审核！</div></div></div></div></div>", 1))
  ]))
}
}

})